<template>
  <div class="all-projects">
    <div v-if="isEmployee">
      <PageHeader title="Projects" :action="{ title: 'New Project', to: { name: 'CreateProject' } }" />
      <ProjectsTable />
    </div>

    <div v-else-if="isCustomer">
      <PageHeader title="My Projects" />
      <CustomerProjectsListing />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ProjectsTable from '../components/ProjectsTable.vue'
import CustomerProjectsListing from '../components/CustomerProjectsListing.vue'
import PageHeader from '@/components/app/AppPageHeader.vue'
import { useHead } from '@unhead/vue'
import { useAuth } from '@/composables/useAuth'

useHead({ title: 'Projects' })

const { isEmployee, isCustomer } = useAuth()
</script>
